import { FormikProps } from "formik";
import moment from "moment";
import ATMLoadingButton from "src/components/UI/atoms/ATMLoadingButton/ATMLoadingButton";
import ATMDatePicker from "src/components/UI/atoms/formFields/ATMDatePicker/ATMDatePicker";
import ATMSelect from "src/components/UI/atoms/formFields/ATMSelect/ATMSelect";
import useDispositionLevelOne from "src/hooks/useDisPositions";
import useInquiryLabels from "src/hooks/useInquiryLabels";
import { InquiryFilterDialogValues } from "src/models/Inquiry.model";
import { useGetAllDispositionLevelTwoByLevelOneIdQuery } from "src/services/DispositionLevelTwoServices";

type Props = {
  formikProps: FormikProps<InquiryFilterDialogValues>;
  onClose: () => void;
  handleReset: () => void;
};

const InquiryFilterDialog = ({ formikProps, onClose, handleReset }: Props) => {
  const { values, setFieldValue, isSubmitting, handleBlur } = formikProps;

  //APIS
  const { inquiryLabels, isDataLoading: inquiryLabelsLoading } =
    useInquiryLabels();

  const { DispositionLevelOne, isDataLoading: isDispositionLevelOneLoading } =
    useDispositionLevelOne();
  const {
    data: DispositionLevelTwoData,
    isLoading: DispositionLevelTwoDataIsLoading,
    isFetching: DispositionLevelTwoDataIsFetching,
  } = useGetAllDispositionLevelTwoByLevelOneIdQuery(values?.dispositionOne?.value, {
    skip: !values?.dispositionOne?.value,
  });

  //   Options
  //Inquiry Label Option
  const InquiryLabelOptions = inquiryLabels?.map((el: any, ind: any) => {
    return {
      label: el?.inquiryLabel,
      value: el?._id,
    };
  });

  const DispositionLevelOneOption = DispositionLevelOne?.map((el: any) => {
    return {
      label: el?.dispositionFirstName,
      value: el?._id,
    };
  });

  const DispositionLevelTwoOption = DispositionLevelTwoData?.data?.map(
    (el: any) => {
      return {
        label: el?.dispositionSecondName,
        value: el?._id,
      };
    }
  );

  return (
    <div className="p-4 flex flex-col gap-6">
      <div className="flex justify-between items-center">
        <div className="text-xl font-medium"> Filters </div>
        <button type="button" className="hover:bg-hover text-red-700 font-medium" onClick={handleReset}>
          Reset Filters
        </button>
      </div>
      <div className="flex flex-col gap-3">
        {/* Inquiry Date */}
        <div className="border-l-[3px] border-primary-dark px-3 font font-medium text-[18px]  bg-white  text-primary-dark">
          Inquiry Date
        </div>
        <div className="grid grid-cols-2 gap-6">
          <div>
            <ATMDatePicker
              name="startDate"
              value={values.startDate}
              onChange={(newValue) => setFieldValue("startDate", newValue)}
              label="Start Date"
              format="DD-MM-YYYY"
              maxDate={moment().format("yyyy-MM-DD")}
            />
          </div>

          <div>
            <ATMDatePicker
              name="endDate"
              value={values.endDate}
              onChange={(newValue) => setFieldValue("endDate", newValue)}
              label="End Date"
              format="DD-MM-YYYY"
              minDate={values?.startDate || null}
            />
          </div>
        </div>
        {/* Next FollowUp Date */}
        <div className="border-l-[3px] border-primary-dark px-3 font font-medium text-[18px]  bg-white  text-primary-dark">
          Next FollowUp Date
        </div>
        <div className="grid grid-cols-2 gap-6">
          <div>
            <ATMDatePicker
              name="nextFollowupStartDate"
              value={values?.nextFollowupStartDate}
              onChange={(newValue) =>
                setFieldValue("nextFollowupStartDate", newValue)
              }
              label="Start Date"
              format="DD-MM-YYYY"
              maxDate={moment().format("yyyy-MM-DD")}
            />
          </div>

          <div>
            <ATMDatePicker
              name="nextFollowupEndDate"
              value={values?.nextFollowupEndDate}
              onChange={(newValue) =>
                setFieldValue("nextFollowupEndDate", newValue)
              }
              label="End Date"
              format="DD-MM-YYYY"
              minDate={values?.nextFollowupEndDate || null}
            />
          </div>
        </div>
        {/* Last FollowUp Date */}
        {/* <div className="border-l-[3px] border-primary-dark px-3 font font-medium text-[18px]  bg-white  text-primary-dark">
          Last FollowUp Date
        </div>
        <div className="grid grid-cols-2 gap-6">
          <div>
            <ATMDatePicker
              name="lastFollowupStartDate"
              value={values?.lastFollowupStartDate}
              onChange={(newValue) =>
                setFieldValue("lastFollowupStartDate", newValue)
              }
              label="Start Date"
              format="DD-MM-YYYY"
              maxDate={moment().format("yyyy-MM-DD")}
            />
          </div>

          <div>
            <ATMDatePicker
              name="lastFollowupStartDate"
              value={values?.lastFollowupStartDate}
              onChange={(newValue) =>
                setFieldValue("lastFollowupStartDate", newValue)
              }
              label="End Date"
              format="DD-MM-YYYY"
              minDate={values?.nextFollowupEndDate || null}
            />
          </div>
        </div> */}
        {/* Disposition's */}
        <div className="border-l-[3px] border-primary-dark px-3 font font-medium text-[18px]  bg-white  text-primary-dark mt-4">
          Disposition's
        </div>

        <div className="grid xl:grid-cols-2 md:grid-cols-1 gap-4 my-2">
          <div>
            <ATMSelect
              name="dispositionOne"
              value={values?.dispositionOne}
              onChange={(newValue) => {
                setFieldValue("dispositionOne", newValue);
                setFieldValue("dispositionTwo", null);
              }}
              onBlur={handleBlur}
              label="Disposition One"
              placeholder="Select Disposition One"
              options={DispositionLevelOneOption}
              isLoading={isDispositionLevelOneLoading}
            />
          </div>
          <div>
            <ATMSelect
              name="dispositionTwo"
              value={values?.dispositionTwo}
              onChange={(newValue) => {
                setFieldValue("dispositionTwo", newValue);
              }}
              onBlur={handleBlur}
              label="Disposition Two"
              placeholder="Select Disposition Two"
              options={DispositionLevelTwoOption}
              isLoading={
                DispositionLevelTwoDataIsLoading ||
                DispositionLevelTwoDataIsFetching
              }
            />
          </div>
        </div>
         {/* Inquiry Label */}
         <div className="">
          <ATMSelect
            name="inquirylabel"
            value={values?.inquirylabel}
            onChange={(value) => setFieldValue("inquirylabel", value)}
            options={InquiryLabelOptions}
            label="Inquiry Label"
            isLoading={inquiryLabelsLoading}
          />
        </div>
      </div>
      <div className="flex gap-2">
        <button
          type="button"
          className="border  font-medium w-full rounded p-2 h-[42px] flex gap-2 justify-center items-center bg-slate-200 hover:bg-slate-300"
          onClick={onClose} // Call onClsoe when clicked the button
        >
          Close
        </button>
        <ATMLoadingButton isLoading={isSubmitting} type="submit">
          Apply
        </ATMLoadingButton>
      </div>
    </div>
  );
};

export default InquiryFilterDialog;
